import { PropsWithChildren, createContext, useContext } from "react";
import { HInfo } from "../../components/HInfo/HInfo";
import { setCoreConfig } from "../../config";
import { InfoProps } from "../../types";

export type CoreConfigContextProps = {
  appName: string;
  appVersion: string;
  allowedPaths: string[];
  defaultPath: string;
  assets?: {
    Info?: React.ComponentType<InfoProps>;
  };
  onOpenChatRequest?: () => void;
  onCloseChatRequest?: () => void;
};

const CoreConfigContext = createContext<CoreConfigContextProps>({
  appName: "no-name",
  allowedPaths: [],
  defaultPath: "",
  appVersion: "no-version",
  assets: {
    Info: HInfo,
  },
});

export const CoreConfigProvider = (
  props: PropsWithChildren & CoreConfigContextProps,
) => {
  const { children, ...rest } = props;
  // pass the same value to the coreConfig module so that non react components can access it
  setCoreConfig(rest);

  if (!rest.appName || !rest.appVersion) {
    throw new Error("App Name and App Version are required");
  }

  return (
    <CoreConfigContext.Provider value={rest}>
      {children}
    </CoreConfigContext.Provider>
  );
};

export const useCoreConfig = () => useContext(CoreConfigContext);
